import { com } from '@eidu/web'
import EntityType = com.eidu.entity.type.EntityType
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import FieldType = com.eidu.entity.field.FieldType
import Field = com.eidu.entity.field.Field

export const isReferenceType = (fieldType: FieldType): boolean =>
  fieldType === FieldType.Reference || fieldType === FieldType.ReferenceSet

export const getReferenceTypeIdsFromField = (field: Field): EntityTypeId[] => {
  if (isReferenceType(field.type))
    return field.validReferenceTypes?.asJsReadonlySetView()?.let((it) => Array.from(it)) || []
  else return []
}

export const getReferenceTypeIdsFromType = (entityType: EntityType): EntityTypeId[] =>
  entityType.fields
    .asJsReadonlyArrayView()
    .filter((it) => isReferenceType(it.type))
    .flatMap((it) => getReferenceTypeIdsFromField(it))
